import {
  workspaceV1GetTermsOptions,
  workspaceV1GetTermsQueryKey,
  WorkspaceV1GetTermsResponse,
} from '@antimatterhq/asl-api-ts-v1';
import { useQueryClient } from '@tanstack/react-query';
import { useSuspenseQuery } from '@antimatterhq/ui/hooks/queries/useSuspenseQuery';
import { defaultOptions } from '@/utils/query';

export const useGetTermsOptions = (workspace: string) => {
  return useSuspenseQuery({
    ...workspaceV1GetTermsOptions({
      ...defaultOptions(),
      path: {
        workspace,
      },
    }),
    retry: false,
  });
};

export const useOptimisticAcceptTerms = (workspace: string) => {
  const queryClient = useQueryClient();

  return (termsAccepted: boolean) => {
    queryClient.setQueryData(
      workspaceV1GetTermsQueryKey({ ...defaultOptions(), path: { workspace } }),
      (prev: WorkspaceV1GetTermsResponse) => {
        return prev ? { termsAccepted } : prev;
      },
    );
  };
};
